import { useState, useEffect } from "react";

function NewAlbumModal({t}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const ALBUM_PROMO_KEY = "viewed_follow_the_fire_promo_2026";

  useEffect(() => {
    const hasSeenPromo = localStorage.getItem(ALBUM_PROMO_KEY);
    if (!hasSeenPromo) {
      setIsOpen(true);
      const timer = setTimeout(() => setIsMounted(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsMounted(false);
    setTimeout(() => {
      localStorage.setItem(ALBUM_PROMO_KEY, "true");
      setIsOpen(false);
    }, 300);
  };

  if (!isOpen) return null;

  return (
    /* Responsieve container:
      - Mobiel: onderaan het scherm geplakt (`bottom-0 left-0 right-0`), geen padding.
      - Desktop (sm:): rechtsonderin zwevend (`sm:bottom-6 sm:right-6 sm:left-auto`), max-width 384px.
    */
    <div className="fixed bottom-0 left-0 right-0 sm:left-auto sm:right-6 sm:bottom-20 z-[9999] w-full sm:max-w-sm p-0 sm:p-0 pointer-events-none">
      <div 
        className={`
          relative bg-gray-900 border-t border-white/20 sm:border border-white/10 rounded-t-2xl sm:rounded-2xl p-5 pl-7 text-white pointer-events-auto
          shadow-[0_-0px_20px_rgba(255,255,255,0.3)] sm:shadow-[0_0px_20px_rgba(255,255,255,0.3)] overflow-hidden
          transition-all duration-300 ease-out
          ${isMounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full sm:translate-y-12"}
        `}
      >
        <div className="absolute top-0 left-0 h-full w-1.5 bg-white hidden sm:block" />
        <div className="absolute top-0 left-0 right-0 h-1 bg-white sm:hidden" />
        
        <button 
          onClick={handleClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-white text-2xl font-light leading-none transition-colors"
        >
          ×
        </button>

        {/* Inhoud */}
        <div className="pr-6">
          <h2 className="text-lg sm:text-xl font-bold tracking-tight text-white">
            {t("popup.title", "New album!")}
          </h2>
          <p className="text-slate-400 text-xs mt-0.5 mb-4 leading-relaxed">
            {t("popup.subtitle", "Ons gloednieuwe album is nu uit! Ontdek het verhaal achter de muziek.")}
          </p>
        </div>

        <div className="flex gap-3 items-center">
          <a 
            href="https://open.spotify.com/track/7tmckLUNaXYsoMC5IONbKI?si=8452f12da9634fb7" 
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClose}
            className="bg-white text-black px-5 py-2.5 sm:px-4 sm:py-2 rounded-full text-xs font-bold hover:bg-slate-200 transition-colors shadow-md text-center"
          >
            {t("releases.listen", "Listen now!")}
          </a>
          <button 
            onClick={handleClose}
            className="text-xs font-semibold text-slate-400 hover:text-white transition-colors px-2 py-2"
          >
            {t("popup.close", "Close now")}
          </button>
        </div>

      </div>
    </div>
  );
}

export default NewAlbumModal;